import React, { useEffect } from "react";
import { trackHowToPlayViewed } from '../../utils/activityTracker';
import useAchievements from '../../hooks/useAchievements';
import { useAuth } from '../../contexts/AuthContext';
import './Aoe2UnitsHowToPlay.scss';

const HowToPlayContent = () => (
  <>
    <h2 className="aoe2-units-how-to-play__title">How to Play: Age of Empires II</h2>
    <ul className="aoe2-units-how-to-play__list">
      <li className="aoe2-units-how-to-play__list-item">
        Try to guess the name of an <b>Age of Empires II unit</b> chosen at random!
      </li>
      <li className="aoe2-units-how-to-play__list-item">
        Each guess is checked against the secret unit's <b>Age</b>, <b>Building</b>, <b>Type</b>, <b>Range</b>, and <b>Cost</b>.
      </li>
      <li className="aoe2-units-how-to-play__list-item">
        <span className="aoe2-units-how-to-play__highlight-color aoe2-units-how-to-play__highlight-color--blue">Blue</span> means your guess is a perfect match for that category.<br />
        <span className="aoe2-units-how-to-play__highlight-color aoe2-units-how-to-play__highlight-color--yellow">Yellow</span> indicates a partial match (for Cost only).<br />
        <span className="aoe2-units-how-to-play__highlight-color aoe2-units-how-to-play__highlight-color--pink">Pink</span> means no match.
      </li>
      <li className="aoe2-units-how-to-play__list-item">
        For <b>Cost</b>, yellow means your guess shares at least one resource type with the correct unit (e.g., your guess of 'Food/Wood' for an answer of 'Food/Gold').
      </li>
      <li className="aoe2-units-how-to-play__list-item">
        For <b>Age</b>, pink cells with arrows indicate if the correct value is higher (↑) or lower (↓).
      </li>
      <li className="aoe2-units-how-to-play__list-item">
        After 5 incorrect guesses, you can reveal a hint for the unit's exact resource cost!
      </li>
    </ul>
    <div className="aoe2-units-how-to-play__tip">
      <b>Tip:</b> Use the <b>Unit Directory</b> to browse units and filter them to narrow down your next guess.
    </div>
  </>
);

const Aoe2UnitsHowToPlay = ({ show, onClose, gameId }) => {
  const { handleNewAchievements } = useAchievements();
  const { isAuthenticated } = useAuth();
  
  // Track when the modal is shown (only for authenticated users)
  useEffect(() => {
    if (show && gameId && isAuthenticated) {
      const trackGuideView = async () => {
        const response = await trackHowToPlayViewed(gameId);
        if (response && response.newAchievements && response.newAchievements.length > 0) {
          handleNewAchievements(response.newAchievements);
        }
      };
      trackGuideView();
    }
  }, [show, gameId, isAuthenticated, handleNewAchievements]);

  if (!show) return null;

  return (
    <div className="aoe2-units-how-to-play" onClick={onClose}>
      <div className="aoe2-units-how-to-play__panel" onClick={e => e.stopPropagation()}>
        <button className="aoe2-units-how-to-play__close-button" onClick={onClose}>
          ✕
        </button>
        <HowToPlayContent />
      </div>
    </div>
  );
};

export default Aoe2UnitsHowToPlay;